import { render } from "./ListFavourites.vue?vue&type=template&id=ee553210"
import script from "./ListFavourites.vue?vue&type=script&lang=js"
export * from "./ListFavourites.vue?vue&type=script&lang=js"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__